import { faCheckCircle } from "@jewlr/pro-solid-svg-icons/faCheckCircle"
import { Box, FontAwesomeIcon } from "@jewlr/storybook/core"
import styled from "styled-components"

import {
  Text,
  StyledLink,
  ButtonLink,
  InputWrapper,
  TitleContainer,
  FormTitle,
  FormContainer,
} from "../components"

const CompleteTitle = styled(FormTitle).attrs((props) => ({
  color: props.theme.colors.greenDarker,
  ...props.theme.order.completeTitle,
}))``

const Complete = () => (
  <FormContainer>
    <TitleContainer
      alignItems={{ _: "flex-start", tablet: "center" }}
      flexDirection={{ _: "column", tablet: "row" }}
    >
      <FontAwesomeIcon
        color="greenDarker"
        fontSize="24px"
        icon={faCheckCircle}
        mb={{ _: "10px", tablet: 0 }}
        mr={{ tablet: 2 }}
      />
      <CompleteTitle>Your Order Change Request Has Been Received</CompleteTitle>
    </TitleContainer>

    <Text>
      Thank you. If you need any further assistance, please{" "}
      <StyledLink color="black" data-lc="complete" to="/helpdesk/contact">
        contact us here
      </StyledLink>
      .
    </Text>
    <br />
    <Text>
      You will receive a confirmation email with your changes and updated
      shipping date.
    </Text>
    <Text mb={3}>Please ensure your updates are correct!</Text>
    <Box py={3}>
      <InputWrapper>
        <ButtonLink
          data-cy="payments-continue-shopping-btn"
          data-lc="complete"
          to="/"
        >
          Continue Shopping
        </ButtonLink>
      </InputWrapper>
    </Box>
  </FormContainer>
)

export default Complete
